import React from 'react'
import PropTypes from 'prop-types'

import { Loader, Copy, themeColor } from '@elparking/components'

import styled from 'styled-components'
import Item from './Item'
import EmptyChargingPoints from './Empty'
import { injectIntl } from 'react-intl'
import messages from './messages'

export const ChargingPointListTitle = styled.div`
    padding: 20px;
    font-weight: 600;
    font-size: 17px;
    background: rgba(0,0,0,0.02);
    color: ${themeColor('gray')};
`

export const NotFoundResult = styled.div`
    padding: 0.5em 0 4em 0;
    background: ${themeColor('white')};
    img { max-width: 100%; }
`

class List extends React.PureComponent {
    static propTypes = {
        chargingPoints: PropTypes.array,
        selected: PropTypes.number,
        marked: PropTypes.number,
        cardComponent: PropTypes.elementType,
        error: PropTypes.object,
        isLoading: PropTypes.bool,
        onSelect: PropTypes.func,
        computeDistanceTo: PropTypes.func,
        onMarkAndCenter: PropTypes.func,
        intl: PropTypes.object,
    }

    static defaultProps = {
        chargingPoints: [],
        selected: null,
        marked: null,
        error: null,
        isLoading: false,
        cardComponent: () => <div />,
        computeDistanceTo: () => null,
        onMarkAndCenter: () => null,
        onSelect: () => null,
    }

    renderLoader () {
        return (
            <Copy align='center' padding='20px'>
                <Loader size='20px' />
            </Copy>
        )
    }

    renderError ({ message }) {
        return (
            <Copy align='center' padding='20px'>
                {message}
            </Copy>
        )
    }

    renderEmpty () {
        return (
            <EmptyChargingPoints />
        )
    }

    renderChargingPoints (chargingPoints) {
        const {
            selected,
            marked,
            cardComponent: Card,
            computeDistanceTo,
            onSelect,
            onMarkAndCenter,
        } = this.props
        return (chargingPoints.map((chargingPoint) => {
            return (
                <Item
                  onSelect={() => onSelect(chargingPoint.id)}
                  onUnselect={() => onSelect(null)}
                  key={chargingPoint.id}
                  isSelected={chargingPoint.id === selected}
                >
                    <Card
                      onMark={() => onMarkAndCenter(chargingPoint)}
                      isSelected={chargingPoint.id === selected}
                      isMarked={chargingPoint.id === marked}
                      chargingPoint={chargingPoint}
                      distance={computeDistanceTo(
                        chargingPoint.latitude,
                        chargingPoint.longitude)
                      }
                    />
                </Item>
            )
        }))
    }

    renderNotFound () {
        return <NotFoundResult>
            { this.renderEmpty() }
        </NotFoundResult>
    }

    renderUnavailableChargingPointsTitle () {
        const { intl } = this.props
        return <ChargingPointListTitle>{intl.formatMessage(messages.unavailableList)}</ChargingPointListTitle>
    }

    render () {
        const { error, isLoading, chargingPoints } = this.props

        if (error) {
            return this.renderError(error)
        }

        if (isLoading) {
            return this.renderLoader()
        }

        if (!chargingPoints.length) {
            return this.renderEmpty()
        }

        return (
            <ul>
                { this.renderChargingPoints(chargingPoints) }
            </ul>
        )
    }
}

export default injectIntl(List)
